export default {
  title_change_password: "Change Password",
  input_current_password: "Password",
  input_new_password: "New password",
  input_repetition: "Repeat new password",
  password_changed: "Password changed successfully",
  password_incorrect: "The current password is incorrect",
  password_requirements:
    "Password must contain a minimum of 10 characters including 1 upper-case letter, 1 lower-case letter, 1 number and one special symbol, e.g. #$!%&",
  requirement_one_lowercase: "Include one lowercase",
  requirement_one_number: "Include one number",
  requirement_one_special_char: "Include one special character",
  requirement_one_uppercase: "Include one uppercase",
  requirement_same_as_old: "New password is the same as the Current password",
  requirement_max_char: "Maximum 128 characters",
  requirement_min_char: "Minimum 10 characters",
  password_mismatch: "Passwords do not match!",
}
